namespace GeniuzPOS.InitialData {
    export namespace PsDiscCouponTypeMbService {
        export const baseUrl = 'InitialData/PsDiscCouponTypeMb';

        export declare function Create(request: Serenity.SaveRequest<PsDiscCouponTypeMbRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsDiscCouponTypeMbRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsDiscCouponTypeMbRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsDiscCouponTypeMbRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsDiscCouponTypeMb/Create",
            Update = "InitialData/PsDiscCouponTypeMb/Update",
            Delete = "InitialData/PsDiscCouponTypeMb/Delete",
            Retrieve = "InitialData/PsDiscCouponTypeMb/Retrieve",
            List = "InitialData/PsDiscCouponTypeMb/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsDiscCouponTypeMbService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
